import { Configuration, PopupRequest,LogLevel  } from "@azure/msal-browser";
// import { AD_appId, AD_tenantID, deploymentURL } from "../config/config";

// Config object to be passed to Msal on creation

const endpoint = process.env.REACT_APP_deploymentURL;

// const endpoint="http://localhost:3000/"



export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AD_appId||'',
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AD_tenantID}`,
        redirectUri:endpoint,
        postLogoutRedirectUri:endpoint
    },
    cache:{
        cacheLocation:'localStorage',
        storeAuthStateInCookie:false
    },
    system: {
        // loggerOptions: {
        //     logLevel: LogLevel.Trace,
        //     loggerCallback: (level, message, containsPii) => {
        //         if (containsPii) {
        //             return;
        //         }
        //         switch (level) {
        //             case LogLevel.Error:
        //                 debugger
        //                 console.error(message);
        //                 return;
        //             case LogLevel.Info:
        //                 debugger
        //                 console.info(message);
        //                 return;
        //             case LogLevel.Verbose:
        //                 debugger
        //                 console.debug(message);
        //                 return;
        //             case LogLevel.Warning:
        //                 debugger
        //                 console.warn(message);
        //                 return;
        //             default:
        //                 debugger
        //                 console.log(message);
        //                 return;
        //         }
        //     }
        // },
        allowNativeBroker: false // Disables WAM Broker
        
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};